const FAITH_INVITATION_ID = 'ehlyianha-faith-gil-debut';
const FAITH_PRINTABLE_PATH = '/invitations/custom/ehlyianha-faith-gil-debut/printable';

function getActiveSeatCheckerInvitationId() {
  const invitationLabel = Array.from(document.querySelectorAll('p')).find((paragraph) =>
    String(paragraph.textContent || '').trim().startsWith('Invitation ID:'),
  );

  return String(invitationLabel?.querySelector('strong')?.textContent || '').trim();
}

if (!window.__seatCheckerPrintableRedirectsInstalled) {
  window.__seatCheckerPrintableRedirectsInstalled = true;

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const button = target.closest('button');
    if (!button || !/Go To Printable Copy/i.test(button.textContent || '')) return;
    if (getActiveSeatCheckerInvitationId() !== FAITH_INVITATION_ID) return;

    // Run before the SeatChecker fallback modal handler and go directly to the
    // protected printable route. The active seat-checker access code remains in
    // localStorage, so PrintableGuard allows the page to open.
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    window.location.assign(FAITH_PRINTABLE_PATH);
  }, true);
}
